import { Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SavedFilters } from 'src/app/models/SavedFilters';
import { SavedFilter } from 'src/app/components/dialogs/select-filter-new/models/saved-filter';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Filter } from '../models/ui/filter.model';
import { FilterResourceToFilterMapper } from '../models/mappers/filter-resource-to-filter.mapper';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../services/app-config.service';

@Injectable({
	providedIn: 'root'
})
export class FiltersSdk extends SdkBase {
	constructor(injector: Injector, private http: HttpClient, private appConfigService: AppConfigService) {
		super(injector);
	}

	public post(params: PostFiltersParams): Observable<Filter> {
		return this.http.post<Filter>(`${this.appConfigService.getConfig().webApi}/api2/filters`, params?.filters).pipe(
			map((response) => {
				const mapper = new FilterResourceToFilterMapper();
				return mapper.map(response);
			}));
	}
}

interface PostFiltersParams {
	filters: SavedFilters | SavedFilter;
}
